import ParsingCarDeleteButton from './ParsingCarDeleteButton';

export default ParsingCarDeleteButton;